export default __webpack_public_path__ + "static/media/Icons_Arrows_Caret_Right_Bold.a6527329.svg";